import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Card, Alert, Row, Col } from 'react-bootstrap';

const SubDeptModel = () => {
     const navigate = useNavigate();
     const [formData, setFormData] = useState({
          sub_dept: '',
          status: 'A'
     });
     const [error, setError] = useState(null);
     const [success, setSuccess] = useState(null);
     const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://internalhrms.vdcapp.in/backend/api';

     const handleSubmit = async (e) => {
          e.preventDefault();
          try {
               const token = localStorage.getItem('token');
               const response = await fetch(`${BASE_URL}/createSubDept`, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                         sub_dept: formData.sub_dept,
                         status: formData.status
                    })
               });
               const result = await response.json();
               if (result.status) {
                    setSuccess('Sub department created successfully!');
                    setTimeout(() => navigate('/subdept'), 2000);
               } else {
                    setError(result.message || 'Failed to create sub department');
               }
          } catch (error) {
               setError('Error: ' + error.message);
          }
     };

     return (
          <Container className="py-4">
               <Card>
                    <Card.Header className="bg-primary text-white">
                         <h4>Add Sub Department</h4>
                    </Card.Header>
                    <Card.Body>
                         {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
                         {success && <Alert variant="success">{success}</Alert>}

                         <Form onSubmit={handleSubmit}>
                              <Row>
                                   <Col md={6}>
                                        <Form.Group className="mb-3">
                                             <Form.Label>Sub Department Name *</Form.Label>
                                             <Form.Control
                                                  type="text"
                                                  value={formData.sub_dept}
                                                  onChange={(e) => setFormData({ ...formData, sub_dept: e.target.value })}
                                                  required
                                             />
                                        </Form.Group>
                                   </Col>
                                   <Col md={6}>
                                        <Form.Group className="mb-3">
                                             <Form.Label>Status</Form.Label>
                                             <Form.Control
                                                  type="text"
                                                  value="Active"
                                                  disabled
                                                  readOnly
                                             />
                                        </Form.Group>
                                   </Col>
                              </Row>

                              <div className="d-flex gap-2">
                                   <Button variant="primary" type="submit">Save</Button>
                                   <Button variant="secondary" onClick={() => navigate('/subdept')}>Cancel</Button>
                              </div>
                         </Form>
                    </Card.Body>
               </Card>
          </Container>
     );
};

export default SubDeptModel;